import { useDispatch } from 'react-redux';

import {
	DetailsChildrenTab,
	type DetailsPageContentProps,
	type DetailsPageProps
} from 'app/main/components/page-layouts';

import CoursesListItem from 'app/main/modules/courses/CoursesListItem';

import SkillsDetailsTab from './tabs/SkillsDetailsTab';
import getSkillsEvaluationsTableColumns from '../skills-evaluations/SkillsEvaluationsTableColumns';

type SkillsEvaluationsChildrenTabProps = Pick<DetailsPageContentProps, 'model' | 'refresh' | 'updateRefresh'>;

function SkillsEvaluationsChildrenTab(props: SkillsEvaluationsChildrenTabProps) {
	const dispatch = useDispatch();

	return (
		<DetailsChildrenTab
			module="skills_evaluations"
			content={{
				type: 'table',
				getColumns: ({ t, updateRefresh }) => getSkillsEvaluationsTableColumns({ dispatch, t, updateRefresh })
			}}
			refresh={props.refresh}
			updateRefresh={props.updateRefresh}
			defaultFilters={[{ filt_field: 'skev_skll_uid', filt_clause: 'equals', filt_value: props.model.skll_uid }]}
			// filters={[{ filt_field: 'skev_d_to', filt_clause: 'is_null' }]}
		/>
	);
}

const tabs: DetailsPageProps['tabs'] = [
	{
		id: 'summary',
		title: 'TAB_SUMMARY',
		content: props => <SkillsDetailsTab {...props} />
	},
	{
		id: 'evaluations',
		title: 'TAB_EVALUATIONS',
		disabled: ({ isEdit }) => isEdit,
		content: ({ model, refresh, updateRefresh }) => (
			<SkillsEvaluationsChildrenTab model={model} refresh={refresh} updateRefresh={updateRefresh} />
		)
	},
	{
		id: 'courses',
		title: 'TAB_COURSES',
		disabled: ({ isEdit }) => isEdit,
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('courses') || authorizer.cannot('view', 'courses'),
		content: ({ model, refresh, updateRefresh }) => (
			<DetailsChildrenTab
				module="courses"
				content={{ type: 'list', itemLayout: CoursesListItem }}
				refresh={refresh}
				updateRefresh={updateRefresh}
				defaultFilters={[{ filt_field: 'crss_skll_uid', filt_clause: 'equals', filt_value: model.skll_uid }]}
			/>
		)
	}
];

export default tabs;
